import { Component } from '@angular/core';
import { RutFormComponent } from './rut-form/rut-form.component';
import { DataService } from './services/data.service';
import { CommonModule } from '@angular/common';
import { SendLinksHeaderComponent } from './send-links-header/send-links-header.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [RutFormComponent, SendLinksHeaderComponent, CommonModule],
})
export class AppComponent {
  title = 'Total Abogados - Pagos Online';

  get isLoading(): boolean { return this.dataService.loading; }
  get currentStep(): number { return this.dataService.step; }
  get orders(): any[] { return this.dataService.orders; }

  constructor(
    private dataService: DataService,
  ) {
    console.log('prod:', environment.production);
  }

  goToMainSite() {
    window.location.href = 'https://www.totalabogados.cl';
  }
}
